export default __webpack_public_path__ + "static/media/logo-ct.de8b3b8c.png";